import { normalizeBoolean, normalizeFiniteNumber, normalizePrivacyRequired } from './normalize';
import { OptimizerRecommendation } from './types';

const EVIDENCE_VERSION = 'popup_optimizer_2026_08_21_v1';

const recommendation = (
  input: Omit<OptimizerRecommendation, 'evidenceVersion'>
): OptimizerRecommendation => ({ ...input, evidenceVersion: EVIDENCE_VERSION });

export function evaluatePhonePrivacy(field: any): OptimizerRecommendation | null {
  if (!field || field.type !== 'Mobile Number') return null;
  if (normalizeBoolean(field.enablePrivacyCheck) !== true) return null;
  if (normalizeBoolean(field.enablePrivacyCheckValue) !== false) return null;
  if (normalizePrivacyRequired(field.privacyCheckRequired) !== false) return null;
  return recommendation({
    strategyId: 'require_phone_privacy_consent',
    placement: 'phone_privacy_required',
    title: '【诊断建议】"隐私勾选"建议设为必填',
    reason: '若设为选填，用户即便填了手机号，未主动勾选隐私协议时也会被视为未订阅，无法进入营销短信发送范围',
  });
}

export function evaluateFirstStepPhone(settings: any, hasMiddlePage: boolean): OptimizerRecommendation | null {
  const startFields = settings?.start;
  if (hasMiddlePage || !Array.isArray(startFields) || startFields.length < 2) return null;
  if (startFields.filter((field: any) => field?.type === 'Mobile Number').length !== 1) return null;
  return recommendation({
    strategyId: 'split_phone_second_step',
    placement: 'first_step',
    title: '【诊断建议】第二步收手机号，填写率更高',
    reason: '分步收集两项资料，降低访客决策成本，比同屏一次性收集填写率更优',
  });
}

export function evaluateIcon(position: any): OptimizerRecommendation | null {
  if (!position || normalizeBoolean(position.iconShow) !== false) return null;
  return recommendation({
    strategyId: 'enable_close_icon',
    placement: 'icon',
    title: '【诊断建议】开启icon提交率更高',
    reason: '开启icon后，访客能随手打开弹窗留资，转化表现更好。若您更在意页面质感，可在素材库挑选更贴合风格的样式',
  });
}

export function evaluateDelay(rules: any): OptimizerRecommendation | null {
  if (!rules || normalizeBoolean(rules.loadingCountDownShow) !== true) return null;
  const value = normalizeFiniteNumber(rules.loadingCountDown);
  if (value === undefined || value >= 5) return null;
  return recommendation({
    strategyId: 'delay_at_least_5s',
    placement: 'delay',
    title: '【诊断建议】延长加载倒计时',
    reason: '访客先浏览页面 5 秒及以上再邀请填写，打扰感更低、提交率更好',
  });
}

export function evaluateScrollPixel(rules: any): OptimizerRecommendation | null {
  if (!rules || normalizeBoolean(rules.loadingPageSlideShow) !== true) return null;
  if (rules.loadingPageSlideType !== 'Pixel') return null;
  const value = normalizeFiniteNumber(rules.loadingPageSlidePixel);
  if (value === undefined || value >= 400) return null;
  return recommendation({
    strategyId: 'scroll_pixel_at_least_400',
    placement: 'scroll_pixel',
    title: '【诊断建议】增加下滑像素',
    reason: '访客向下滚动 400px 及以上再触发弹窗，减少刚进入页面就被打断的情况，提交率表现更好',
  });
}
